import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const TagCategoryCodec = t.intersection([
  t.type({
    id: t.string,
    key: t.string,
    label: t.string,
    doNotUse: t.boolean,
  }),
  t.partial({
    description: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export type TagCategory = t.TypeOf<typeof TagCategoryCodec>;

@Exclude()
export class TagCategoryEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  key!: string;

  @Expose()
  label!: string;

  @Expose()
  description?: string;

  @Expose()
  doNotUse!: boolean;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = "TAGCATEGORY";

  get displayName(): Readonly<string> {
    return this.label ?? this.key ?? this.id;
  }

  constructor() {
  }

  static from(value: TagCategory): TagCategoryEntity {
    return plainToInstance(TagCategoryEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<TagCategory> {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSON(TagCategoryCodec, object);
  }

  asTypeValue(): TagCategory {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSONNow(TagCategoryCodec, object);
  }
}
